var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.invoice!=null)?_c('div',[_c('InvoiceDetails',{attrs:{"invoice":_vm.invoice}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }